module.exports = __webpack_public_path__ + "static/media/M1-30-Worgnulf-cod149-B.46703eb2.png";